import {
    TRYING_REMINDERS_ACTION,
    TRYING_REMINDERS_ACTION_SUCCESS,
    TRYING_REMINDERS_ACTION_ERROR
} from '../Types';

const INITIAL_STATE = {
    TryingRemindersAction: false,
    TryingRemindersActionError: null,
};

export default (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case TRYING_REMINDERS_ACTION:
            return { ...state, TryingRemindersAction: true, TryingRemindersActionError: null };
        case TRYING_REMINDERS_ACTION_ERROR:
            return { ...state, TryingRemindersAction: false, TryingRemindersActionError: action.payload };
        case TRYING_REMINDERS_ACTION_SUCCESS:
            return { ...state, TryingRemindersAction: false, TryingRemindersActionError: null };
        default:
            return state;
    }
};
